"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseLang = void 0;
const useGlobalState_1 = require("powerhooks/useGlobalState");
const urlSearchParams_1 = require("powerhooks/tools/urlSearchParams");
const id_1 = require("tsafe/id");
const symToStr_1 = require("tsafe/symToStr");
const typeGuard_1 = require("tsafe/typeGuard");
function createUseLang(params) {
    const { languages, fallbackLanguage } = params;
    const name = "lang";
    const { useLang, $lang } = (0, useGlobalState_1.createUseGlobalState)({
        name,
        "initialState": (() => {
            const lang = getLanguageBestApprox({
                "languageLike": navigator.language,
                languages
            });
            if (lang === undefined) {
                return fallbackLanguage;
            }
            return lang;
        })(),
        "doPersistAcrossReloads": true
    });
    {
        const next = (lang) => document.documentElement.setAttribute(name, lang);
        next($lang.current);
        $lang.subscribe(next);
    }
    read_url: {
        const result = (0, urlSearchParams_1.retrieveParamFromUrl)({
            "url": window.location.href,
            name
        });
        if (result.wasPresent) {
            (0, urlSearchParams_1.updateSearchBarUrl)(result.newUrl);
            if (!(0, typeGuard_1.typeGuard)(result.value, (0, id_1.id)(languages).includes(result.value))) {
                break read_url;
            }
            $lang.current = result.value;
        }
    }
    [...languages, undefined].forEach(lang => {
        const link = document.createElement("link");
        link.rel = "alternate";
        link.hreflang = lang === undefined ? "x-default" : lang;
        link.href =
            lang === undefined
                ? window.location.href
                : (0, urlSearchParams_1.addParamToUrl)({
                    "url": window.location.href,
                    name,
                    "value": lang
                }).newUrl;
        document.getElementsByTagName("head")[0].appendChild(link);
    });
    function getLanguageBestApprox(params) {
        const { languages, languageLike } = params;
        scope: {
            const lang = languages.find(lang => lang.toLowerCase() === languageLike.toLowerCase());
            if (lang === undefined) {
                break scope;
            }
            return lang;
        }
        scope: {
            const iso2LanguageLike = languageLike.split("-")[0].toLowerCase();
            const lang = languages.find(lang => lang.toLowerCase().includes(iso2LanguageLike));
            if (lang === undefined) {
                break scope;
            }
            return lang;
        }
        return undefined;
    }
    return {
        useLang,
        [(0, symToStr_1.symToStr)({ $lang })]: (0, id_1.id)($lang)
    };
}
exports.createUseLang = createUseLang;
